module.exports = __webpack_public_path__ + "img/Lactation.8f1f2a75.png";